export const theme = {
  token: {
    colorPrimary: '#6366f1',
    colorSuccess: '#10b981',
    colorWarning: '#f59e0b',
    colorError: '#ef4444',
    colorInfo: '#06b6d4',
    colorLink: '#6366f1',
    
    borderRadius: 12,
    borderRadiusLG: 16,
    borderRadiusSM: 8,
    
    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    
    colorBgContainer: '#ffffff',
    colorBgLayout: '#f8fafc',
    colorBgElevated: '#ffffff',
    
    colorBorder: '#e2e8f0',
    colorBorderSecondary: '#f1f5f9',
    
    colorText: '#0f172a',
    colorTextSecondary: '#64748b',
    colorTextTertiary: '#94a3b8',
    
    boxShadow: '0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)',
    boxShadowSecondary: '0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)',
    boxShadowTertiary: '0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)',
    
    controlHeight: 40,
    controlHeightLG: 48,
    controlHeightSM: 32,
    
    motionDurationMid: '0.2s',
    motionEaseInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
  },
  
  components: {
    Button: {
      borderRadius: 10,
      controlHeight: 40,
      controlHeightLG: 48,
      controlHeightSM: 32,
      primaryShadow: '0 2px 4px rgb(99 102 241 / 0.2)',
      defaultShadow: '0 1px 2px rgb(0 0 0 / 0.05)',
    },
    
    Card: {
      borderRadiusLG: 16,
      boxShadowTertiary: '0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)',
      headerBg: 'transparent',
      paddingLG: 24,
    },
    
    Input: {
      borderRadius: 10,
      controlHeight: 40,
      activeShadow: '0 0 0 3px rgb(99 102 241 / 0.1)',
    },
    
    Select: {
      borderRadius: 10,
      controlHeight: 40,
    },
    
    Table: {
      borderRadius: 12,
      headerBg: '#f8fafc',
      headerColor: '#64748b',
      rowHoverBg: '#f1f5f9',
      borderColor: '#e2e8f0',
    },
    
    Menu: {
      itemBorderRadius: 10,
      itemMarginInline: 8,
      itemPaddingInline: 16,
      itemHeight: 44,
      iconSize: 18,
    },
    
    Modal: {
      borderRadiusLG: 20,
      titleFontSize: 18,
    },
    
    Drawer: {
      borderRadiusLG: 20,
    },
    
    Tabs: {
      itemColor: '#64748b',
      itemSelectedColor: '#6366f1',
      inkBarColor: '#6366f1',
    },
    
    Tag: {
      borderRadiusSM: 6,
    },
    
    Badge: {
      dotSize: 8,
    },
    
    Avatar: {
      borderRadius: 10,
    },
  },
};

export const sidebarTheme = {
  bg: 'linear-gradient(180deg, #0f172a 0%, #1e293b 100%)',
  text: '#cbd5e1',
  textActive: '#ffffff',
  itemHoverBg: 'rgba(255, 255, 255, 0.08)',
  itemSelectedBg: 'rgba(99, 102, 241, 0.15)',
  itemSelectedColor: '#ffffff',
};
